// @ts-nocheck
import client from "../../utils/axios";
import { useQuery, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { AuthGetWecomUrlQueryResponse, AuthGetWecomUrlQueryParams, AuthGetWecomUrl401 } from "../models/AuthGetWecomUrl";
import type { QueryObserverOptions, UseQueryResult, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";

 type AuthGetWecomUrlClient = typeof client<AuthGetWecomUrlQueryResponse, AuthGetWecomUrl401, never>;
type AuthGetWecomUrl = {
    data: AuthGetWecomUrlQueryResponse;
    error: AuthGetWecomUrl401;
    request: never;
    pathParams: never;
    queryParams: AuthGetWecomUrlQueryParams;
    headerParams: never;
    response: AuthGetWecomUrlQueryResponse;
    client: {
        parameters: Partial<Parameters<AuthGetWecomUrlClient>[0]>;
        return: Awaited<ReturnType<AuthGetWecomUrlClient>>;
    };
};
export const authGetWecomUrlQueryKey = (params: AuthGetWecomUrl["queryParams"]) => ["api", "v5", "auth", "wecom", "login-url", ...(params ? [params] : [])] as const;
export type AuthGetWecomUrlQueryKey = ReturnType<typeof authGetWecomUrlQueryKey>;
export function authGetWecomUrlQueryOptions(params: AuthGetWecomUrl["queryParams"], options: AuthGetWecomUrl["client"]["parameters"] = {}) {
    const queryKey = authGetWecomUrlQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<AuthGetWecomUrl["data"], AuthGetWecomUrl["error"]>({
                method: "get",
                url: `/api/v5/auth/wecom/login-url`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary 使用企业微信登录
 * @link /api/v5/auth/wecom/login-url
 */
export function useAuthGetWecomUrl<TData = AuthGetWecomUrl["response"], TQueryData = AuthGetWecomUrl["response"], TQueryKey extends QueryKey = AuthGetWecomUrlQueryKey>(params: AuthGetWecomUrl["queryParams"], options: {
    query?: Partial<QueryObserverOptions<AuthGetWecomUrl["response"], AuthGetWecomUrl["error"], TData, TQueryData, TQueryKey>>;
    client?: AuthGetWecomUrl["client"]["parameters"];
} = {}): UseQueryResult<TData, AuthGetWecomUrl["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? authGetWecomUrlQueryKey(params);
    const query = useQuery({
        ...authGetWecomUrlQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseQueryResult<TData, AuthGetWecomUrl["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}
export const authGetWecomUrlSuspenseQueryKey = (params: AuthGetWecomUrl["queryParams"]) => ["api", "v5", "auth", "wecom", "login-url", ...(params ? [params] : [])] as const;
export type AuthGetWecomUrlSuspenseQueryKey = ReturnType<typeof authGetWecomUrlSuspenseQueryKey>;
export function authGetWecomUrlSuspenseQueryOptions(params: AuthGetWecomUrl["queryParams"], options: AuthGetWecomUrl["client"]["parameters"] = {}) {
    const queryKey = authGetWecomUrlSuspenseQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<AuthGetWecomUrl["data"], AuthGetWecomUrl["error"]>({
                method: "get",
                url: `/api/v5/auth/wecom/login-url`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary 使用企业微信登录
 * @link /api/v5/auth/wecom/login-url
 */
export function useAuthGetWecomUrlSuspense<TData = AuthGetWecomUrl["response"], TQueryKey extends QueryKey = AuthGetWecomUrlSuspenseQueryKey>(params: AuthGetWecomUrl["queryParams"], options: {
    query?: Partial<UseSuspenseQueryOptions<AuthGetWecomUrl["response"], AuthGetWecomUrl["error"], TData, TQueryKey>>;
    client?: AuthGetWecomUrl["client"]["parameters"];
} = {}): UseSuspenseQueryResult<TData, AuthGetWecomUrl["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? authGetWecomUrlSuspenseQueryKey(params);
    const query = useSuspenseQuery({
        ...authGetWecomUrlSuspenseQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseSuspenseQueryResult<TData, AuthGetWecomUrl["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}